import { useTheme, Box, Typography, IconButton, Tooltip } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import SpeedDialMenu from '../../menu/SpeedDialMenu';
import MoneyLabel from '../../label/MoneyLabel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const Service = ({ service, actions, toggleExpand }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { t } = useTranslation();

  return (
    <Box>
      <Box className="w-full flex justify-between pr-[2px] items-center">
        <Box className="flex gap-2 pt-1">
          {service.useAbsolute == '0' && (
            <Tooltip title={`${t('Total value share')}`}>
              <Typography fontWeight={600}>
                {service.percentOfHonorarium + '%'}
              </Typography>
            </Tooltip>
          )}
          <Typography fontWeight={600}>{service.label}</Typography>
        </Box>

        {toggleExpand && (
          <IconButton onClick={() => toggleExpand(service)}>
            {service.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </Box>

      {service.expanded && (
        <Box className="relative flex">
          <Box className="w-full">
            <Box className="flex flex-col items-start gap-1">
              <Box className="w-full flex justify-between">
                <Typography>{t('Costs')}</Typography>
                <MoneyLabel money={service.amount ?? 0} />
              </Box>
              <Box className="w-full flex justify-between">
                <Typography className="w-[180px]">
                  {`${t('Proportion of personnel costs')}`}
                </Typography>
                <Typography>
                  {(service.personelCostOfPhasePercent ?? 0) + '%'}
                </Typography>
              </Box>
              <Box className="w-full flex justify-between">
                <Typography>{t('Personnel Costs')}</Typography>
                <MoneyLabel
                  money={service.personelCostOfPhasePercentAmount ?? 0}
                />
              </Box>
            </Box>
          </Box>
          {actions && (
            <>
              <Box className="w-[50px]" />
              <SpeedDialMenu
                key={'SpeedDialMenuEmpClass' + service.id}
                className="absolute right-0 top-0"
                actions={actions}
              />
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
export default Service;
